module.exports = __webpack_public_path__ + "img/2041.32cb6fac.png";